import Loadable from 'react-loadable';
import PropagateLoader from '../components/pageLoader/PropagateLoader';
import Forgot from '../containers_v2/auth/password/Forgot';
import Reset from '../containers_v2/auth/password/Reset';

// subRoutes
import { ObjectAction } from '../web-types/objectActions';
import ReportView from '../containers_v2/reports/reportView';
import CalendarRoutes from './subRoutes/CalendarRoutes';
import CompaniesRoutes from './subRoutes/CompaniesRoutes';
import CompanyMapRoutes from './subRoutes/CompanyMapRoutes';
import ContactsRoutes from './subRoutes/ContactsRoutes';
import OpportunitiesRoutes from './subRoutes/OpportunitiesRoutes';
import DashboardRoutes from './subRoutes/DashboardRoutes';
import FileManagerRoutes from './subRoutes/FileManagerRoutes';
import FormsRoutes from './subRoutes/FormsRoutes';
import OAuthRoutes from './subRoutes/OAuthRoutes';
import OrdersRoutes from './subRoutes/OrdersRoutes';
import ProductsRoutes from './subRoutes/ProductsRoutes';
import ProductsRoutesV2 from './subRoutes/ProductsRoutesV2';
import PromotionsRoutes from './subRoutes/PromotionsRoutes';
import ReportsRoutes from './subRoutes/ReportsRoutes';
import SystemSettingsRoutes from './subRoutes/SystemSettingsRoutes';
import NotFound from '../containers_v2/globals/404';

export interface SubRoute {
	path: string;
	name: string | JSX.Element;
	permission?: ObjectAction[];
	cumulative?: boolean;
	beta?: boolean;
	subMenu?: string;
	admin?: boolean;
	owner?: boolean;
	hashs?: string[];
}

export interface Route {
	component: (props) => JSX.Element | null;
	path: string;
	key?: string;
	exact?: boolean;
	subMenu?: string;
	menu?: boolean;
	role?: string[];
	sectionKey?: string;
	title?: string | JSX.Element;
	subTitle?: string | JSX.Element;
	restricted?: boolean;
	logoImg?: JSX.Element;
	hoverImg?: JSX.Element;
	activeImg?: JSX.Element;
	permission?: ObjectAction[];
	submenu?: boolean;
	precedence?: number;
	name?: string | JSX.Element;
	beta?: boolean;
	subroutes?: SubRoute[];
	detail?: string | JSX.Element;
	subPath?: string;
	admin?: boolean;
	owner?: boolean;
	parent?: Route;
	logoSize?: string;
	hashs?: string[];
}

const App = Loadable({
	loader: async() => await import('./App'),
	loading: PropagateLoader
});

// const LegacyApp = Loadable({
//   loader: () => import('./LegacyApp'),
//   loading: PropagateLoader
// });

const Login = Loadable({
	loader: async() => await import('../containers_v2/auth/login/Login'),
	loading: PropagateLoader
});

const NotValid = () => {
	window.location.href = '/404';
};

const routes: Route[] = [
	{
		component: Login,
		path: '/login',
		key: 'login',
		exact: true
	},
	{
		component: Forgot,
		path: '/password/forgot',
		key: 'forgot',
		exact: true
	},
	{
		component: Reset,
		path: '/password/reset',
		key: 'forgot',
		exact: true
	},
	{
		component: ReportView,
		path: '/report-view',
		key: 'report-view',
		exact: true
	},
	...CalendarRoutes(),
	...CompanyMapRoutes(),
	...CompaniesRoutes(),
	...ProductsRoutes(),
	...OAuthRoutes(),
	...ContactsRoutes(),
	...OpportunitiesRoutes(),
	...OrdersRoutes(),
	...PromotionsRoutes(),
	...FormsRoutes(),
	...ReportsRoutes(),
	...SystemSettingsRoutes(),
	...ProductsRoutesV2(),
	...DashboardRoutes(),
	...FileManagerRoutes(),
	{
		component: NotFound,
		path: '/404',
		key: 'notFound',
		exact: true
	},
	{
		component: NotValid,
		path: '*',
		key: 'notValid',
		exact: true
	}
];

export default [
	{
		component: App,
		path: '/',
		routes
	}
];
